// @ts-nocheck
import { styled } from '@mui/material/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useState, useCallback, useMemo } from 'react';

import DatePicker from '../../../../../Common/DatePicker';
import { defaultInputStyles, defaultSxStyles } from './fieldsStyles';
import {
  DATE_FORMAT,
  DD_MM_YYYY_DATE_FORMAT,
  YYYY_MM_DD_DATE_FORMAT,
} from '../../../../../../const/CommonConst';

const StyledDateField = styled(DatePicker)({
  width: '100%',
  height: '100%',
  '& .MuiInputBase-root': {
    height: '100%',
    padding: 0,
  },
  '& .MuiInputBase-input': {
    height: '100%',
    padding: '0 4px',
    fontSize: '14px',
    // Make input clickable for calendar
    cursor: 'pointer',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  // Hide calendar icon
  '& .MuiInputAdornment-root': {
    display: 'none',
  },
});

const DateField = ({
  value,
  onChange,
  format = {},
  inputRef,
  onFocus,
  onBlur,
  ...props
}) => {
  const [open, setOpen] = useState(false);

  const parsed = useMemo(() => {
    return value
      ? moment(
          value,
          [
            YYYY_MM_DD_DATE_FORMAT,
            DATE_FORMAT,
            DD_MM_YYYY_DATE_FORMAT,
            moment.ISO_8601,
          ],
          true
        )
      : null;
  }, [value]);

  const momentValue = parsed && parsed.isValid() ? parsed : null;

  const handleChange = useCallback(
    (newValue) => {
      onChange(
        newValue && moment(newValue).isValid()
          ? moment(newValue).format(YYYY_MM_DD_DATE_FORMAT)
          : null
      );
    },
    [onChange]
  );

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleClick = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  return (
    <StyledDateField
      open={open}
      onClose={handleClose}
      value={momentValue}
      onChange={handleChange}
      error={false}
      helperText=""
      required={false}
      onFocus={onFocus}
      onBlur={onBlur}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          variant: 'outlined',
          inputRef,
          onClick: handleClick,
          sx: {
            ...defaultSxStyles,
            ...props.sx,
          },
          inputProps: {
            ...props.inputProps,
            style: {
              ...defaultInputStyles,
              ...format,
            },
            readOnly: true, // Make input read-only but keep it interactive
          },
        },
      }}
      {...props}
    />
  );
};

DateField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.shape({}).isRequired,
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  sx: PropTypes.shape({}).isRequired,
  inputProps: PropTypes.shape({}).isRequired,
};

export default DateField;
